"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGridRowRenderer = void 0;
const react_1 = __importDefault(require("react"));
const GridRowCell_1 = require("./components/GridRowCell/GridRowCell");
const GridRowContainer_1 = require("./components/GridRowContainer/GridRowContainer");
function createGridRowRenderer(config) {
    return function renderGridRow({ index, width, height, style, topOffset, getDataByIndex, columns, className, handlers, disabled, selected, isOddRow, loading: initialLoading, inactive, idGetter }) {
        const rowDataItem = getDataByIndex(index);
        const loading = initialLoading ? initialLoading : !Boolean(rowDataItem);
        const rowDataItemId = rowDataItem ? idGetter(rowDataItem) : null;
        return react_1.default.createElement((config === null || config === void 0 ? void 0 : config.container) || GridRowContainer_1.GridRowContainer, {
            className,
            disabled,
            inactive,
            isOddRow,
            selected,
            style: Object.assign({ minWidth: width, height: height, top: `${topOffset}px` }, style),
            onClick: handlers === null || handlers === void 0 ? void 0 : handlers.onClick,
            onContextMenu: handlers === null || handlers === void 0 ? void 0 : handlers.onContextMenu,
            onDoubleClick: handlers === null || handlers === void 0 ? void 0 : handlers.onDoubleClick
        }, columns.map((colConfig, colIndex) => {
            const key = rowDataItemId
                ? `row-${rowDataItemId}-cell-${colConfig.id}`
                : `row-skeleton-${index}-cell-${colConfig.id}`;
            return (react_1.default.createElement(GridRowCell_1.GridRowCell, { key: key, renderer: colConfig.cell, width: colConfig.width || 0, loading: loading, payload: {
                    rowData: rowDataItem,
                    rowIndex: index,
                    cellIndex: colIndex,
                    column: {
                        id: colConfig.id,
                        width: colConfig.width || 0,
                        flex: colConfig.flex,
                        justify: colConfig.justify,
                        highlighted: colConfig.highlighted
                    },
                    disabled,
                    inactive,
                    selected,
                    isOddRow
                } }));
        }));
    };
}
exports.createGridRowRenderer = createGridRowRenderer;
//# sourceMappingURL=createGridRowRenderer.js.map